import React, { Component } from 'react';

class Nature extends Component {
	render() {
		return (
			<section className="nature">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-6">
							<div className="nature__content">
								<h1 className="nature__title">Simplicity <em>meets </em>Sustainability</h1>
								<p className="nature__description">We understand finding the right skincare is not easy. That’s why we started Yours. We eliminate guesswork by personalising your skincare routine based on your skin needs, lifestyle, and environment.</p>
								<p className="nature__description"> We are on a mission to make skincare simple and sustainable, so you never have to worry about taking care of yourself.</p>
							</div>
						</div>
					</div>
				</div>
				<img className="nature__bg" src="/images/nature-and-science.png" alt="" />
			</section>
		);
	}
}


export default Nature;